import { Input } from "@/frontend/components/ui/input";

export function FormField({
  label, optional, ...inputProps
}: {
  label: string;
  optional?: boolean;
} & React.ComponentProps<typeof Input>) {
  return (
    <div>
      <label className="text-xs font-medium text-foreground block mb-1">
        {label}
        {optional && (
          <span className="italic opacity-50 ml-1">
            (optional)
          </span>
        )}
      </label>
      <Input className="text-sm h-9" {...inputProps} />
    </div>
  );
}
